<template>
<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :append-to-body="true" :center="false" :wrapperClosable="false">
    <el-form label-width="120px">
        <el-form-item label="请选择供应商">
            <el-select v-model="ruleForm.supplier_id" clearable filterable @change="getSupplier">
                <el-option v-for="(item,index) in suppliers" placeholder="请选择供应商" :key="index" :label="item.title" :value="item.id+''"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="请选择产品">
            <el-select v-model="ruleForm.product_id" clearable filterable @change="getProduct">
                <el-option v-for="(item,index) in productList" placeholder="请选择产品" :key="index" :label="item.title" :value="item.id+''"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="价格">
            <el-input v-model="ruleForm.product.price" disabled type="input" placeholder="产品单价"></el-input>
        </el-form-item>
        <el-form-item label="自定义价格">
            <el-input v-model="ruleForm.price" placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="ruleForm.remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">确认</el-button>
            <el-button @click="closeDrawer">取消</el-button>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
const ruleForm = {
    supplier_id: "",
    product_id: "",
    price: '',
    remark: '',
    supplier: {},
    product: {}

};
export default {
    props: {
        parent: {}
    },
    data() {
        return {
            supplier_id: '',
            dialogVisible: false,
            ruleForm: Object.assign({}, ruleForm),
            suppliers: [],
            forms: [],
            cid: 0,
            applyItem: {},
            productList: {},
            price: '',
            dialogTitle:''
        }
    },
    methods: {
        showDialog(applyItem,title) {
            let _this = this;
            _this.dialogVisible = true;
            _this.dialogTitle =title
            _this.applyItem = applyItem;
            _this.ruleForm = Object.assign({}, ruleForm);
            _this.ruleForm.remark = applyItem.remark
            _this.ruleForm.product.price = '';
            _this.getSuppliers()
        },
        closeDrawer() {
            this.dialogVisible = false;
        },
        getSuppliers() {
            let _this = this;
            let url = '/api/supplier.company/index';
            let params = {
                category_parent_id: 2,
            };
            _this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.suppliers = res.data.list
                }
            })
        },
        getSupplier(supplier_id) {
            let _this = this;
            let url = '/api/supplier.product/group';
            let params = {
                supplier_id: supplier_id,
                zone: "control_project"
            };
            _this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.productList = res.data.list;
                    if(_this.productList.length==0){
                            _this.ruleForm.product.price = '';
                    }
                    _this.ruleForm.product_id = '';
                    let supplier = _this.suppliers.find(ele => ele.id == supplier_id);
                    _this.ruleForm.supplier = {
                        id: supplier_id,
                        title: supplier.title
                    }

                }
            })
        },
        getProduct(product_id) {
            let _this = this;
            let product = _this.productList.find(ele => ele.id == product_id);
            _this.ruleForm.product.price = product.price;
            _this.ruleForm.product = {
                id: product_id,
                title: product.title,
                price:product.price
            }
        },
        submit() {
            if (this.ruleForm.supplier_id == '') {
                this.$message({
                    type: 'danger',
                    message: '请选择供应商'
                });
                return false;
            }
            if (this.ruleForm.product_id == '') {
                this.$message({
                    type: 'danger',
                    message: '请选择产品'
                });
                return false;
            }
            //return false
            this.applyItem = Object.assign(this.applyItem, this.ruleForm);

            this.parent.$forceUpdate();
            this.dialogVisible = false;
        }
    }
}
</script>
